import { render, staticRenderFns } from "./AppPhone.vue?vue&type=template&id=0f31706c&"
import script from "./AppPhone.vue?vue&type=script&lang=js&"
export * from "./AppPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports